import React from "react";

const bubbleTail = ({ fill, secondaryFill, rotate }) => (
  <svg
    className="bubbleTail"
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="49"
    viewBox="0 0 64 49"
    fill="none"
  >
    <path
      d="M63.5 0L0 1L0.632069 1.23378C23.6345 9.74154 42.4184 26.8748 53 49L63.5 0Z"
      fill={fill}
    />
  </svg>
);

export default bubbleTail;
